import { ThunkType } from "../../../../core/store/reducers";
import getTradeApi from "../api/getTrade";
import { setDisplayed } from "../tradesDataSlice";
import { Trades } from "../types";

export const loadTrade = (tradeId: string): ThunkType => async (
  dispatch,
  getStore
) => {
  dispatch(setDisplayed());

  const trade = await dispatch(getTrade(tradeId));

  dispatch(setDisplayed(trade));
};

export const getTrade = (
  tradeId: string
): ThunkType<Promise<Trades | undefined>> => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { userId } = store.data.auth.current.user;
  return await dispatch(getTradeApi(userId, tradeId));
};
